import React from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';
import Link from '@nubank/nuds-web/components/Link/Link';

const StyledBox = styled(Box)`
  :last-child, :nth-child(4), :nth-child(8) {
    margin-right: 0; /* Exclude margin from the last grid item */
  }

  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  cursor: pointer;

  :hover {
    transform: scale(1.05);
    box-shadow: 0 8px 16px rgb(0 0 0 / 10%);
  }
  
  @media (768px <= width <= 1024px) {
    flex-basis: 100%;
    width: 90%;
    margin-right: 0;
    margin-top: 20px;
  }
`;

const StyledImage = styled(Image)`
  margin: 0 auto;
`;

const BenefitsContainer = styled(Box)`
  @media (768px <= width <= 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;

function MastercardBenefitsGrid({ partnersList, handleItemClick }) {
  return (
    <BenefitsContainer
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
      paddingHorizontal="35px"
      maxWidth="1433px"
      margin="0 auto"
      paddingBottom="100px"
      paddingTop="50px"
      background="linear-gradient(to bottom, white 0%, white 15%, #F8F8FA 15%, #F8F8FA 100%);"
    >
      {partnersList.map((partner, index) => (
        <StyledBox
          key={partner.id}
          flexBasis="calc(25% - 35px);"
          marginRight="35px"
          width="300px"
          height="347px"
          marginTop={index > 3 ? '35px' : '0'}
          paddingTop="26px"
          paddingBottom="30px"
          paddingHorizontal="4x"
          borderRadius="12px"
          background="white"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          onClick={() => handleItemClick(partner.id)}
        >

          <StyledImage
            alt={partner.image.alt}
            src={partner.image.url}
            width="133px"
            height="133px"
            loading="lazy"
            objectFit="contain"
            webp
          />

          <Typography
            variant="subtitle1"
            strong
            marginTop="27px"
            marginBottom="35px"
            textAlign="center"
            totalChars={partner.title.length}
            height="72px"
          >
            {partner.title}
          </Typography>

          {/* Link that works as a button ¯\_(ツ)_/¯ */}

          <Link
            href="###"
            alt="Ver beneficio"
            variant="action"
            iconProps={{
              name: 'arrow-right',
            }}
            onClick={e => {
              e.preventDefault();
              handleItemClick(partner.id);
            }}
          >
            Ver beneficio
          </Link>
        </StyledBox>
      ))}
    </BenefitsContainer>
  );
}

MastercardBenefitsGrid.propTypes = {
  handleItemClick: PropTypes.func.isRequired,
  partnersList: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.string,
      image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
      }),
      moreLink: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
};

export default MastercardBenefitsGrid;
